var productCardMarkup = `<div class="collection-grid swym-wishlist-grid">{{#products}}<div class="col_slide product-item swym-is-anchorc swym-wishlist-item" data-title="{{dt}}"><div class="product-grid snippet-product-grid"data-product-id={{empi}} data-url={{du}} data-variant-id={{epi}} data-variant-name={{vi}} data-wishlist-id={{cts}}><div class=grid-imagebox><div class=main-badge><div class="grid-badge pre-order-badge"><span style="color:#fff;background:#000;display:block">pre-order</span></div><div class="grid-badge sold-out"><span style="color:#fff;background:rgb(149 149 149 / .7);display:block">Sold out</span></div></div><a href={{du}} class=product-link><div class=product-images><img alt=""class="main-imgs packshot-imgs swym-wishlist-image"src=""> <img alt=""class="main-imgs packshot-imgs second-image"src=""></div></a></div><div class=grid-meta><div class=grid-top><div class=grid-meta-inr><p class=grid-title><a href={{du}}>{{dt}}</a><p class="grid-price line-130"><span class="compare-price d-none">{{cu}}<span> </span></span><span class="original-price swym-product-final-price"data-wpd-product-handle=""data-wpd-product-id={{empi}} data-wpd-variant-compare-at-price=""data-wpd-variant-id={{epi}} data-wpd-variant-price="">{{cu}}{{pr}}</span></div><button class="swym-is-button swym-delete-btn swym-nav swym-nav-1"data-product-id={{empi}} data-variant-id={{epi}} id=swym-remove-productBtn aria-label=Delete><span class=swym-icon><svg fill=none height=19 viewBox="0 0 19 19"width=19 xmlns=http://www.w3.org/2000/svg><g id=Heart><path d="M9.99525 4.55687C8.59567 2.85305 6.26183 2.39472 4.50828 3.95492C2.75475 5.51511 2.50788 8.1237 3.88494 9.96893C5.02988 11.5031 8.49485 14.7389 9.63048 15.7861C9.75753 15.9033 9.82109 15.9619 9.89515 15.9849C9.95983 16.005 10.0306 16.005 10.0953 15.9849C10.1693 15.9619 10.2329 15.9033 10.3599 15.7861C11.4956 14.7389 14.9606 11.5031 16.1055 9.96893C17.4825 8.1237 17.2658 5.4987 15.4821 3.95492C13.6985 2.41114 11.3948 2.85305 9.99525 4.55687Z"fill=black id=Vector stroke=black clip-rule=evenodd fill-rule=evenodd stroke-linecap=round stroke-linejoin=round stroke-width=0.5 /></g></svg></span></button></div><div class=grid-btm><div class=wm-btn><div class=size_variant><div class=grid-variant-outer><div class=grid-error></div><div class=selector_btn><button class="change-variant change-variant-btn"data-product-id={{empi}} data-variant-id={{epi}} data-url={{du}} data-variant-name={{vi}}><span>{{vi}}</span> <span><svg fill=none height=5 viewBox="0 0 9 5"width=9 xmlns=http://www.w3.org/2000/svg><path d="M7.30266 1L4.5 4.23624L1.69734 0.999999L7.30266 1Z"fill=black id="Polygon 4"stroke=black /></svg></span></button></div><div class=grid-size-wrapper> </div></div></div><div class=grid-variant-btns><button class="swym-is-button btn btn-black product-addcart site-add-btn swym-add-to-cart-btn w-100"data-product-id={{empi}} data-variant-id={{epi}} id=swym-custom-add-toCartBtn data-product-url={{du}} data-state-cart="{{#isInCart}} swym-added{{/isInCart}}"name=add type=submit><div class="btn-inner relative"><span class="text added-cart main-text">Added to cart</span> <span class="text absolute hover-text top-100 added-cart">Added to cart</span> <span class="text main-text p-add-cart-btn">Add to cart</span> <span class="text absolute hover-text top-100 p-add-cart-btn">Add to cart</span></div></button></div></div></div></div></div></div>{{/products}}</div>`;
var variantModalMarkUp = `<div class=wishlist-sizedrawer id=modal><div class=modal-guts>{{#product.options}}<div class="grid-size-variants select-variant-{{name}}"id=user-options-{{name}}>{{#values}}<div class=sywm-radio data-value={{.}} var-id=""><input data-value={{.}} id="user-option{{.}}_{{ product.id  }}"name="{{name}}_{{ product.id  }}"type=radio> <label for=user-option{{.}}_{{product.id}}>{{.}}<span class=favourite-dots></span></label></div>{{/values}}</div>{{/product.options}}</div></div>`;


function checkAndUpdateWishlistItems() {
    let items = document.querySelectorAll(".swym-wishlist-item");
    if (items.length > 0) {
        items.forEach(function (item) {
          let dtValue = item.getAttribute("data-title");
          if(dtValue && dtValue.includes("VRM")){
            item.classList.add("hide-add-cart");
          }
        });
    } else {
        setTimeout(checkAndUpdateWishlistItems, 500);
    }
}
checkAndUpdateWishlistItems();

// var variantModalMarkUp = `
//   <div class="wishlist-sizedrawer" id="modal">
//     <div class="modal-guts">
//       {{#product.options}}
//         <div class="grid-size-variants select-variant-{{name}}" id="user-options-{{name}}">
//           {{#values}}
//             <div class="sywm-radio" data-value={{.}} var-id="">
//               <input data-value={{.}} id="user-option{{.}}_{{product.id}}" name="{{name}}_{{product.id}}" type="radio">
//               <label for="user-option{{.}}_{{product.id}}">{{.}}<span class="favourite-dots"></span></label>
//             </div>
//           {{/values}}
//         </div>
//       {{/product.options}}
//     </div>
//   </div>`;


function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onRemoveBtnClick(e){
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products){
    products.forEach(function (product){
      if (epi && empi && product.epi == epi && product.empi == empi) {
        document.body.classList.remove("active-wishli-pro");
        const createdUlElements = document.querySelectorAll('.wpp-meta-ul');
        createdUlElements.forEach(ul => ul.remove());
        window._swat.removeFromWishList(product, function(){
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
      if (products.length == 1) {
        document.querySelector('.swym-wishlist-item').innerHTML = '';
      }
    });
  });
}
function price_update(){
  let th_shopify_shop = Shopify.shop;
   const thwlcGetCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++){
      let c = ca[i];
      while (c.charAt(0) == ' '){
        c = c.substring(1);
      }
      if(c.indexOf(name) == 0){
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  Shopify.money_format = document.querySelector('.section-swym').getAttribute('data-money');
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
  
    function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number/100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  };
}
function swymRenderWishlist(swat){
  window.secondTimestamp = Date.now();
  var wishlistContentsContainer = document.getElementById("wishlist-items-container");
  var wishlistProducts = JSON.parse(localStorage.getItem("wishlistProducts")) || [];
  swat.fetch(function(products){
    if(!products || products.length === 0){
      console.log("No new wishlist data found.");
      return;
    }
    var formattedWishlistedProducts = products.map(function(p, n){
      var productId = p.empi;
      var variantId = p.epi;
      var du = p.du;
      var params = {
        du: du,
        empi: parseInt(productId),
        epi: parseInt(variantId),
      };
      var storedProductJson = wishlistProducts.find(item => item.id === productId);
      if (storedProductJson){
        // console.log('ifff',products.length);
        updateProductUI(storedProductJson, p, n, products.length);
      }else{
        // console.log('elsee', products.length);
        window._swat.getProductDetails(params, function (productJson){
          // console.log('elsee*----in',productJson);
          if(productJson){
            productJson.du = du;
            let existingProduct = wishlistProducts.find(item => item.id === productJson.id);
            if (!existingProduct){
              wishlistProducts.push({
                id: productJson.id,
                du: productJson.du,
                ...productJson
              });
              localStorage.setItem("wishlistProducts", JSON.stringify(wishlistProducts));
            }
            updateProductUI(productJson, p, n, products.length);
          }
        });
      }
      return SwymUtils.formatProductPrice(p);
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });
    if(wishlistContentsContainer){
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      window.thirdTimestamp = Date.now();
      attachClickListeners();
    }else{
      console.log("Container not found, Wishlist Page element not found");
    }
  });
}
function updateProductUI(productJson,p,n,counts){
  var contantValue = 0;
  function recursive(){
    let grid = document.querySelectorAll('#wishlist-items-container .snippet-product-grid').length;
    if(grid > 0 || contantValue === 30){
      if(grid){
        let current_curreny = document.querySelector('#currency_form .dropdown-toggle').getAttribute('data-currency');
        let price = productJson.price;
        let handle = productJson.handle;
        let compare_at_price = productJson.compare_at_price;
        price_update();
        if(window.location.href.includes('.com/pages') == false){
          let extention = window.location.href.split('/pages')[0].split('/').pop();
          fetch('/'+extention+'/products/'+productJson.handle+'.json')
          .then(response => response.json())
          .then((data) => {
            let variants = data.product.variants;
            variants.forEach(function(value){
              if(value.id == p.epi){
                let formattedPrice = Shopify.formatMoney(value.price, Shopify.money_format);
                document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').textContent = formattedPrice;
                document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-variant-price',value.price);
                document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-variant-price',value.price);
                document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-product-handle',handle);
                if(value.compare_at_price != ''){
                  document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price').classList.remove("d-none");
                  document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price span').textContent = Shopify.formatMoney(value.compare_at_price, Shopify.money_format);
                  document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-variant-compare-at-price',value.compare_at_price);
                  if (value.compare_at_price > value.price) {
                    document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-meta-inr').classList.add("pro-sale");     
                    let saving = ((value.compare_at_price - value.price) * 100) / value.compare_at_price;
                    function customRound(value) {
                      let remainder = value % 5;
                      if (remainder <= 2) {
                        return value - remainder;
                      } else {
                        return value + (5 - remainder);
                      }
                    }
                  }
                }else{
                  document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').style.color = "#464545";
                  document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price').classList.add("d-none");
                }
              }
            })
          })
          .catch(error => console.error('Error fetching product:', error));
        }else{
          let formattedPrice = Shopify.formatMoney(price, Shopify.money_format);
          document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').textContent = formattedPrice;
          document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-variant-price',price);
          document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-variant-price',price);
          document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-product-handle',handle);
          if(compare_at_price != null){
            document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price').classList.remove("d-none");
            document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price span').textContent = compare_at_price / 100;
            document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').setAttribute('data-wpd-variant-compare-at-price',compare_at_price);
            if (compare_at_price > price) {
              document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-meta-inr').classList.add("pro-sale");     
              let saving = ((compare_at_price - price) * 100) / compare_at_price;
              function customRound(value) {
                let remainder = value % 5;
                if (remainder <= 2) {
                  return value - remainder;
                } else {
                  return value + (5 - remainder);
                }
              }
            }
          }else{
            document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .original-price').style.color = "#464545";
            document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .compare-price').classList.add("d-none");
          }
        }

        setTimeout(() => {
          productJson.du = p.du;
          var variantMarkUpTemplate = SwymUtils.renderTemplateString(
            variantModalMarkUp,
            {
              product: productJson,
            }
          );
          document.querySelectorAll('.snippet-product-grid[data-product-id="' +p.empi+'"] .grid-size-wrapper').forEach((variantAdd) => {
            variantAdd.innerHTML = variantMarkUpTemplate;
          });
          if (n == counts - 1) {
            attachModalEventListeners();
          }
          let tag_list = productJson.tags;
          tag_list.forEach(function(tag){
            if(tag == "PRE-ORDER"){
              console.log(tag,'ionnnn----tag----===---',document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"]').closest(".product-item"));
              document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"]').closest(".product-item").classList.add('pre-order');
              document.querySelectorAll('.snippet-product-grid[data-product-id="' +productJson.id +'"] .p-add-cart-btn').forEach((addText) => {
                addText.textContent = "Pre-order";
              });
            }
          });
          document.querySelectorAll('.wishlist-content .snippet-product-grid[data-wishlist-id="' +p.cts +'"]').forEach(function(wl_grid){
            let id = parseInt(wl_grid.getAttribute('data-variant-id'));
            let variant_list = productJson.variants;
            variant_list.forEach(function(i, value){
              let all_id = i.id;
              if(all_id == id){
                if(i.available == false && productJson.available == true){
                  document.querySelectorAll('.snippet-product-grid[data-wishlist-id="' +p.cts +'"] .p-add-cart-btn').forEach((addText) => {
                    addText.textContent = "Sold out";
                  });
                  document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"]').classList.add("variant_soldout");
                }
                return false;
              }
            })
          })
          // if(productJson.variants[0].available == false && productJson.available == true){
          //   document.querySelectorAll('.snippet-product-grid[data-product-id="' +productJson.id +'"] .p-add-cart-btn').forEach((addText) => {
          //     addText.textContent = "Sold out";
          //   });
          //   document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"]').classList.add("variant_soldout");
          // }
          
          console.log('productJson', productJson);
          // const sizeOption = productJson.options.find(option => option.name.toLowerCase() === "size");
          const sizeOption = productJson.options.find(option => {
            const optionName = option.name.toLowerCase();
            return optionName === "size" || optionName === "maat";
          });
          if(sizeOption && sizeOption.values.length === 1){
            const productElement = document.querySelector('.snippet-product-grid[data-product-id="' + productJson.id + '"]');
            if (productElement) {
              productElement.classList.add('one-size');
              const gridMetaInr = productElement.querySelector('.grid-meta-inr');
              if (gridMetaInr) {
                const oneSizeTextDiv = document.createElement('div');
                oneSizeTextDiv.classList.add('one-size-text');
                if(window.location.href.includes('/nl')){
                  oneSizeTextDiv.textContent = 'één maat';
                }else{
                  oneSizeTextDiv.textContent = "One size";
                }
                gridMetaInr.insertAdjacentElement('afterend', oneSizeTextDiv);
              }
            }
          }else{
            if(productJson.options.length > 1){
              var productElement2 = document.querySelectorAll('.snippet-product-grid[data-product-id="' + productJson.id + '"]');
              productElement2.forEach(function(self){
                var elements = self.querySelector('.change-variant.change-variant-btn span').innerHTML;
                var single_elements = elements.split('/');
                if(single_elements.length > 1){
                  for(option in productJson.options){
                    var single_option = productJson.options[option];
                    if (single_option.name == 'size' || single_option.name == 'Size' || single_option.name == 'SIZE' || single_option.name == 'maat') {
                      self.querySelector('.change-variant.change-variant-btn span').innerHTML = single_elements[option];
                    }
                  }
                }
              });
              // for ((option, index) in product.options) {
              //   console.log('productJSON', option);
              //   console.log('productJSON', index);
              // }
              console.log('productJSON 2', productElement2);
              console.log('productJSON', productJson.options);
            }
          }
          
  
          if(window.location.href.includes('/nl')){
            console.log('innn************************');
            document.querySelectorAll('.snippet-product-grid[data-product-id="' +productJson.id +'"] .p-add-cart-btn').forEach((addText) => {
              if(addText.textContent == 'Pre-order'){
                addText.textContent = "Vooraf bestellen";
              }else if(addText.textContent == 'Add to cart'){
                addText.textContent = "Toevoegen";
              }else if(addText.textContent == 'Sold out'){
                addText.textContent = "Uitverkocht";
              }
            });
            document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .pre-order-badge span').textContent = "Vooraf bestellen";
          }

          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-title a').setAttribute('href',productJson.url);
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .product-link').setAttribute('href',productJson.url);
          document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-title a').textContent = productJson.title;
          
  
          function loadImage(src, selector, callback){
            let img = new Image();
            img.onload = function(){
              let targets = document.querySelectorAll(selector);
              if(targets.length){
                targets.forEach(function(single_target){
                  single_target.setAttribute("src", src);
                })
              }
              if(callback) callback();
            };
            img.src = src;
          }
          if(productJson.images[0]){
            loadImage(productJson.images[0],'#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .swym-wishlist-image');
          }
          if(productJson.images[1]){
            loadImage(productJson.images[1],'#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .second-image');
          } else {
            document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .swym-wishlist-image').style.opacity = "1";
            document.querySelector('#wishlist-items-container .snippet-product-grid[data-product-id="' +productJson.id +'"] .second-image').classList.add("d-none");
          }
  
          // if(productJson.images[0]){
          //   document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .swym-wishlist-image').setAttribute("src", productJson.images[0]);
          // }
          // if(productJson.images[1]){
          //   document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .second-image').setAttribute("src", productJson.images[1]);
          // }else{
          //   document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .swym-wishlist-image').style.opacity = "1";
          //   document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .second-image').classList.add("d-none");
          // }
          
          if(productJson.available == false){
            document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] #swym-custom-add-toCartBtn').classList.add("grid-soldOut");
            document.querySelectorAll('.snippet-product-grid[data-product-id="' +productJson.id +'"] .p-add-cart-btn').forEach((addText) => {
              addText.textContent = "Sold out";
            });
            document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-price').classList.add("soldout_pro");
            document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-meta-inr').classList.add("sold_plus_sale");
          }
          var jsonvariantid = productJson.variants;
          jsonvariantid.forEach(function(i, value){
            const element = document.querySelector('.snippet-product-grid[data-variant-id="' + p.epi + '"] .sywm-radio[data-value="' + i.option1 + '"]');
            if(i.available == false){
              const nextLabel = element.nextElementSibling;
              element.classList.add("soldout_variant")
            }
            if(i.title == p.vi){
              element.checked = !0;
              const nextLabel = element.nextElementSibling;
              element.classList.add("active")
            }
          })
        }, 200);

      }
    }else{
      contantValue++;
      setTimeout(recursive, 10);
    }
  }
  recursive();
  p = SwymUtils.formatProductPrice(p);
  p.pr = p.pr.split('.')[0];
  p.variantinfo = p.variants ? getVariantInfo(p.variants) : "";
  p.isInCart = _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart;
  if (p.vi) {
    if (p.vi.includes("/")) {
      p.vi = p.vi.split("/")[0];
    } else if (p.vi.includes(" ")) {
      p.vi = p.vi.split(" ")[0];
    }
  }
  return p;
}
function attachClickListeners(){
  document.querySelectorAll("#swym-custom-add-toCartBtn").forEach(function(addtocartbtn){
    addtocartbtn.addEventListener("click", function(e){
      e.preventDefault();
      e.stopPropagation();
      const isSoldOut = addtocartbtn.closest('.snippet-product-grid').classList.contains("variant_soldout");
      if(!isSoldOut){
        const variantId = addtocartbtn.closest('.wm-btn').querySelector(".change-variant.change-variant-btn").getAttribute("data-variant-id");
        if(variantId){
          const cartData = {
            id: variantId,
            quantity: 1,
          };
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(cartData),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error("Failed to add product to cart");
              }
              return response.json();
            })
            .then((data) => {
              load_cart();
              const url = '/cart.js';
              fetch(url)
              .then((resp) => resp.json())
              .then(function(data) {
                var cart_count = data.item_count;
                if(cart_count>0){
                  document.querySelectorAll('.cart-count').forEach(function(count){
                    count.innerHTML = cart_count;
                  })
                }else{
                  document.querySelectorAll('.cart-count').forEach(function(count){
                    count.innerHTML = '';
                  })
                }
              })
              .catch(function(error) {
                console.log(error);
              });
              setTimeout(function () {
                document.querySelector("body").classList.add("open-drawer");
              }, 500);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      } else {
        console.log("Cannot add to cart, the variant is sold out.");
      }
    })
  });
  document.body.addEventListener("click", function(e){
    var popup = document.querySelector(".grid-variant-outer.active-variant");
    if(document.querySelector(".grid-variant-outer.active-variant")){
      if(!popup.contains(event.target)){
        document.querySelector(".grid-variant-outer.active-variant").classList.remove('active-variant');
      }
    }
  });
  document.querySelectorAll('.swym-wishlist-item .change-variant.change-variant-btn').forEach(function(changeVariant){
    changeVariant.addEventListener("click", function(e){
      e.preventDefault();
      let parentWishlistItem = changeVariant.closest('.swym-wishlist-item');
      let targetVariant = parentWishlistItem.querySelector('.grid-variant-outer');
      if (!targetVariant) return;
      let isActive = targetVariant.classList.contains('active-variant');
      document.querySelectorAll('.swym-wishlist-item .grid-variant-outer').forEach(function(variant){
        variant.classList.remove('active-variant');
      });
      if(!isActive){
        targetVariant.classList.add('active-variant');
      }
      const productItem = event.target.closest('.product-item .snippet-product-grid');
      if (productItem) {
        const currentID = productItem.getAttribute('data-product-id');
        window._swat.fetch(function (products) {
          const matchedProduct = products.find(p => p.empi.toString() === currentID);
          if (matchedProduct) {
            const params = {
              du: matchedProduct.du,
              empi: parseInt(matchedProduct.empi, 10),
              epi: parseInt(matchedProduct.epi, 10),
            };

            window._swat.getProductDetails(params, function(productJson1){
              if (productJson1.id.toString() === currentID){
                const jsonVariantId = productJson1.variants;
                if (jsonVariantId && jsonVariantId.length > 0){
                  
                  jsonVariantId.forEach(function (variant){
                    if(variant.option1){
                      let sizeElements;
                      if(productItem.querySelector('#user-options-size')){
                        sizeElements = productItem.querySelectorAll('#user-options-size .sywm-radio');
                      }else{
                        sizeElements = productItem.querySelectorAll('#user-options-maat .sywm-radio');
                      }
                      sizeElements.forEach((ele) => {
                        const sizeValue = ele.getAttribute('data-value');
                        if(variant.option1 === sizeValue){
                          ele.setAttribute('var-id',variant.id);
                          if(!variant.available){
                            ele.classList.add("soldout_variant");
                          }else{
                            ele.classList.remove("soldout_variant");
                          }
                        }
                      });
                    }
                    attachModalEventListeners();
                  });
                }
              } else {
                console.warn('No matching product found for ID:', currentID);
              }
            });
          }
        });
      }
    });
  });
  document.querySelectorAll('.grid-title a').forEach(function(titleElement) {
    let title = titleElement.textContent;
    let firstPart = title.split('|')[0].trim();
    titleElement.textContent = firstPart;
  });
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  for(var k = 0; k < removeBtns.length; k++){
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }
}

function attachModalEventListeners() {
  document.querySelectorAll(".product-item .sywm-radio").forEach((radioWrapper) => {
    radioWrapper.addEventListener("change", function(e){
      const parentGrid = e.target.closest(".snippet-product-grid");
      if(!parentGrid){
        return;
      }
      const radioInput = radioWrapper.querySelector("input[type='radio']");
      if(!radioInput){
        return;
      }
      parentGrid.querySelectorAll(".sywm-radio.active").forEach((activeRadio) => activeRadio.classList.remove("active"));
      if(radioInput.checked){
        radioWrapper.classList.add("active");
      }
      parentGrid.querySelector('.change-variant.change-variant-btn').setAttribute('data-variant-name',parentGrid.querySelector(".sywm-radio.active").getAttribute('data-value'));
      parentGrid.querySelector('.change-variant.change-variant-btn').textContent = parentGrid.querySelector(".sywm-radio.active").getAttribute('data-value');
      parentGrid.querySelector('.change-variant.change-variant-btn').setAttribute('data-variant-id',parentGrid.querySelector(".sywm-radio.active").getAttribute('var-id'));
      setTimeout(() => {
        radioWrapper.closest('.grid-variant-outer').classList.remove('active-variant');
      }, 200);
      const isSoldOut = radioWrapper.classList.contains("soldout_variant");
      const isPreOrder = radioWrapper.closest(".product-item").classList.contains("pre-order");
      const addToCartBtn = parentGrid.querySelector("#swym-custom-add-toCartBtn");
      if(isSoldOut){
        addToCartBtn.classList.add("grid-soldOut");
        addToCartBtn.querySelectorAll('.p-add-cart-btn').forEach((addText) => {
          if(window.location.href.includes('/nl')){
            addText.textContent = "Uitverkocht";
          }else{
            addText.textContent = "Sold out";
          }
        });
        addToCartBtn.setAttribute("disabled", "true");
        console.log("This variant is sold out.");
      }
      else{
        addToCartBtn.classList.remove("grid-soldOut");
        if(isPreOrder){
        addToCartBtn.querySelectorAll('.p-add-cart-btn').forEach((addText) => {
          if(window.location.href.includes('/nl')){
            addText.textContent = "Vooraf bestellen";
          }else{
            addText.textContent = "Pre order";
          }          
        });
        }else{
        addToCartBtn.querySelectorAll('.p-add-cart-btn').forEach((addText) => {
          if(window.location.href.includes('/nl')){
            addText.textContent = "Toevoegen";
          }else{
            addText.textContent = "Add to Cart";
          }
        });
        }
        if(addToCartBtn.closest('.snippet-product-grid').classList.contains('variant_soldout')){
          addToCartBtn.closest('.snippet-product-grid').classList.remove('variant_soldout');
        }
        addToCartBtn.removeAttribute("disabled");
        const productId = parentGrid.getAttribute("data-product-id");
        const variantId = radioWrapper.getAttribute("data-variant-id");
        const du = parentGrid.getAttribute("data-url");
        const params = {
          du: du,
          empi: parseInt(productId),
          epi: parseInt(variantId),
        };
        window._swat.getProductDetails(params, function (productJson) {
          addToCartBtn.onclick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!isSoldOut) {
              const activeRadioWrapper = parentGrid.querySelector(".sywm-radio.active");
              const variantId = activeRadioWrapper.getAttribute("var-id");
              const cartData = {
                id: variantId,
                quantity: 1,
              };

              fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(cartData),
              })
                .then((response) => {
                  if (!response.ok) {
                    throw new Error("Failed to add product to cart");
                  }
                  return response.json();
                })
                .then((data) => {
                  load_cart();
                  const url = '/cart.js';
                  fetch(url)
                  .then((resp) => resp.json())
                  .then(function(data) {
                    var cart_count = data.item_count;
                    if(cart_count>0){
                      document.querySelectorAll('.cart-count').forEach(function(count){
                        count.innerHTML = cart_count;
                      })
                    }else{
                      document.querySelectorAll('.cart-count').forEach(function(count){
                        count.innerHTML = '';
                      })
                    }
                  })
                  .catch(function(error) {
                    console.log(error);
                  });
                  setTimeout(function () {
                    document.querySelector("body").classList.add("open-drawer");
                  }, 500);
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            } else {
              console.log("Cannot add to cart, the variant is sold out.");
            }
          }
        });
      }
    });
  });
}
attachModalEventListeners();
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist);

// function addtocartpopup(){
//   const addToCartButton = document.querySelector('.wpp-add-to-cart .swym-add-to-cart-btn');
//   if(addToCartButton.classList.contains("sold-out")){
//     return;
//   }
//   const productId = document.querySelector('.wpp-media-wrap .swym-delete-btn').getAttribute('data-product-id');
//   const variantId = document.querySelector('.wpp-meta-ul li.active').getAttribute('data-variant');
//   const productUrl = document.querySelector('.product-item .snippet-product-grid').getAttribute('data-url');
//   const cartData = {
//     id: variantId,
//     quantity: 1
//   };
//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify(cartData)
//   })
//     .then(response => {
//       if (!response.ok) {
//         throw new Error('Failed to add product to cart');
//       }
//       return response.json();
//     })
//     .then(data => {
//       addToCartButton.setAttribute("data-state-cart", "swym-added");
//       load_cart();
//       setTimeout(function () {
//         document.querySelector("body").classList.add("open-drawer");
//       }, 500);
//     })
//     .catch(error => {
//       console.error('Error:', error);
//     });
// }

// function getSelectTagValues(selector) {
//   var userSelection = {};
//   if (typeof selector !== "undefined") {
//     var optionValue = selector.getAttribute("data-value");
//     if (optionValue != undefined) {
//       var key = "option" + (0 + 2);
//       var selectedValueObj = _defineProperty({}, key, optionValue.toString());
//       if (SwymUtils) {
//         SwymUtils.extendDefaults(userSelection, selectedValueObj);
//       }
//     }
//     return userSelection;
//   } else {
//     console.log("Invalid Option Selector");
//   }
// }
// function _defineProperty(obj, key, value) {
//   if (key in obj) {
//     Object.defineProperty(obj, key, {
//       value: value,
//       enumerable: true,
//       configurable: true,
//       writable: true,
//     });
//   } else {
//     obj[key] = value;
//   }
//   return obj;
// }
// function findVariant(userSelectedOption, completeProductJson1) {
//     var keys = Object.keys(userSelectedOption).filter(function (key) {
//       return (
//         userSelectedOption[key] !== null && userSelectedOption[key] !== undefined
//       );
//     });
  
//   var match = completeProductJson1.variants.find(function (variant) {
//     return keys.every(function (key, value) {
//       return (
//         variant[key] === userSelectedOption[key] &&
//         variant[value] === userSelectedOption[value]
//       );
//     });
//   });
  
//   return match;
// }
// function removeProductFromWishlist(old_product_variant, callback) {
//   window._swat.removeFromWishList(old_product_variant, function (r) {
//     callback(r);
//   });
// }
// function addProductToWishlist(new_product_variant) {
//   window._swat.addToWishList(new_product_variant, function (r) {
//     renderWishlistUI();
//   });
// }
// function renderWishlistUI() {
//   _swat.fetch(function (products) {
//     WishlistedProducts = JSON.parse(JSON.stringify(products));
//     for (let i = 0; i < WishlistedProducts.length; i++) {
//       _swat.getProductDetails(
//         {
//           du: WishlistedProducts[i].du,
//           epi: WishlistedProducts[i].epi,
//           empi: WishlistedProducts[i].empi,
//         },

//         function (fullProductDetails) {
//           for (let j = 0; j < fullProductDetails.variants.length; j++) {
//             var sameid = fullProductDetails.variants[j].id;
//             if (fullProductDetails.variants[j].id == WishlistedProducts[i].epi) {
//               WishlistedProducts[i].available = fullProductDetails.variants[j].available;
//             }
//           }
//         }
        
//       );
//     }

//     setTimeout(function (e) {
//       var h3height = 0;
//     }, 2000);
//     currentUserWishlist = [];
//     var wishlistContentsContainer = document.getElementById(
//       "wishlist-items-container"
//     );
//     currentUserWishlist = products;
//     var completeProductJson = {};
//     var formattedWishlistedProducts = WishlistedProducts.map(function (p, n) {
//       var productId = p.empi;
//       var variantId = p.epi;
//       var variantTitle = p.vi;
//       var du = p.du;
//       var params = {
//         du: du,
//         empi: parseInt(productId),
//         epi: parseInt(variantId),
//       };
//       variantButtonAttributes = {};
//       variantButtonAttributes = params;
//       window._swat.getProductDetails(params, function (productJson) {
//         completeProductJson = productJson;
//         productJson.du = du;
//         var variantMarkUpTemplate = SwymUtils.renderTemplateString(
//           variantModalMarkUp,
//           {
//             product: productJson,
//           }
//         );
//         document.querySelectorAll('.snippet-product-grid[data-product-id="' +productId +'"] .grid-size-wrapper').forEach((variantAdd) => {
//           variantAdd.innerHTML = variantMarkUpTemplate;
//         });
//         if(n == products.length - 1){
//           attachModalEventListeners();
//         }
//         if(productJson.available == false){
//           document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] #swym-custom-add-toCartBtn').classList.add("grid-soldOut");
//           document.querySelectorAll('.snippet-product-grid[data-product-id="' +productJson.id +'"] .p-add-cart-btn').forEach((addText) => {
//             addText.textContent = "Sold out";
//           });
//           document.querySelector('.snippet-product-grid[data-product-id="' +productJson.id +'"] .grid-badge span').textContent = "Sold out";
//         }
//         var jsonvariantid = productJson.variants;
//         jsonvariantid.forEach(function(i, value) {
//           const element = document.querySelector('.snippet-product-grid[data-variant-id="' + variantId + '"] .sywm-radio[data-value="' + i.option1 + '"]');
//           if(i.available == false){
//             const nextLabel = element;
//             element.classList.add("soldout_variant")
//           }
//           var allvarName = i.title;
//           if(i.option1 == variantTitle){
//             element.checked = !0;
//             const nextLabel = element;
//             element.classList.add("active")
//           }
//         })
//       });

//       p = SwymUtils.formatProductPrice(p);
//       p.pr = p.pr.split('.')[0];
//       p.variantinfo = p.variants ? getVariantInfo(p.variants) : "";
//       p.isInCart =
//         _swat.platform.isInDeviceCart(p.epi) ||
//         p.et == _swat.EventTypes.addToCart;
//       if (p.vi) {
//         if (p.vi.includes("/")) {
//           p.vi = p.vi.split("/")[0];
//         } else if (p.vi.includes(" ")) {
//           p.vi = p.vi.split(" ")[0];
//         }
//       }
//       return p;
//     });
//     var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
//       products: WishlistedProducts,
//     });
//     wishlistContentsContainer.innerHTML = productCardsMarkup;
//     attachClickListeners();
//   });
// }